/** True when running inside the Electron desktop shell (preload exposes `window.electron`). */
export function isElectronShell(): boolean {
  return typeof window !== 'undefined' && 'electron' in window;
}
